import React, { Component } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import './demo.css';

// Higher-order component to provide navigation prop to class component
function withNavigation(Component: React.ComponentType<any>) {
    return function (props: any) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };
}

interface DemoProps {
    navigate: NavigateFunction;
}

class Demo extends Component<DemoProps> {
    handleButtonClick = () => {
        this.props.navigate('/form');
    };

    render() {
        return (
            <div className="content-box">
                <h1>ISARA Advance® Cryptographic Inventory and Risk Assessment Tool Demo</h1>
                <div>Introducing a cryptographic management platform that reveals your blind spots, discovers bad usage, and equips you to act</div>
                <div>Cryptography is the foundation of authentication and confidentiality — consequently, it’s a critical enabler of digital security.</div>
                <div>To secure your systems today, to keep them secure tomorrow, and to comply with increasingly stringent regulations and audits, your cryptographic infrastructure needs to be understood, inventoried, and upgraded whenever necessary — without disrupting normal operations.</div>
                <div>That’s why we created ISARA Advance: a cryptographic inventory platform that enables you to discover your cryptographic infrastructure — all from an easy-to-understand and easy-to-use central dashboard.</div>
                <div><i>Advance provides inventories and assessments of the cryptography protecting data-in-motion</i></div>
                <button onClick={this.handleButtonClick}>Request a Demo</button>
            </div>
        );
    }
}

export default withNavigation(Demo);